class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 6V8H22.59L6 24.59L7.41 26L24 9.41V22H26V6H10Z" fill="#16191D"></path></svg>';
  }
}
const t = "pwc-icon-arrow--up-right";
customElements.get(t) || customElements.define(t, e);
